<script>
  import { onMount } from 'svelte';
  import { groups } from 'd3-array';
  // import Core from './Core.svelte';
  import Core from './Core.svelte';
  import ColorLegend from './ColorLegend.svelte';
  import MinutesLegend from './MinutesLegend.svelte';
  import GamesPlayedLegend from './GamesPlayedLegend.svelte';
  import PlayersList from './PlayersList.svelte';

  // let teamEntries = [];
  // onMount(async () => {
  //   const res = await fetch(`/data/winners.json`);
  //   const winners = await res.json();
  //   teamEntries = groups(winners, (d) => d.team_abbr);
  //   // teamEntries = teamEntries.filter((d) => d[0] === 'LAL');
  // });
  export let winners = [];
  const teamEntries = groups(winners, (d) => d.team_abbr);
</script>

<style>
  main {
    padding: 4em;
    width: 820px;
    margin: 0 auto;
  }

  a {
    color: #fff;
    opacity: 0.8;
  }

  a:hover {
    opacity: 1;
  }

  header {
    margin-bottom: 72px;
    color: #9594BD;
  }

  .description {
    color: #9594BD;
    max-width: 70ch;
    line-height: 1.5;
  }

  h1 {
    color: #fff;
    font-size: 48px;
    font-weight: 800;
    margin: 0;
    letter-spacing: -1px;
  }
  .subhead {
    font-size: 24px;
    color: #9594BD;
    margin-bottom: 12px;
  }

  h2 {
    color: #fff;
    font-size: 32px;
    font-weight: 800;
    margin: 0;
    margin-bottom: 12px;
  }
  .legends {
    margin-bottom: 32px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
  }
  .legend-item {
    margin-right: 32px;
  }
  .legend-item:last-child {
    margin-right: 0;
  }

  .core-grid {
    margin: 0 auto;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
  }

  .core-area {
    display: flex;
    align-items: center;
  }
  .core {
    margin-right: 64px;
  }

  .item {
    margin-bottom: 128px;
  }

  em {
    font-weight: 400;
    font-style: normal;
    color: #c0beef;
  }
</style>

<main>
  <header>
    <h1>NBA Winning Cores</h1>
    <div class="subhead">For the 2019-20 season</div>
    <div>By <a href="https://twitter.com/pbesh">Peter Beshai</a></div>
    <div class="description">
      <p>
        I wanted to look at how teams were constructed based on how many <em>winners</em> were on the team – as primary players or locker room presences – so I put together this visualization that breaks down teams based on:
      </p>
      <ul>
        <li> <em>career milestone</em> – how far have they made it in the playoffs?</li>
        <li> <em>career win percentages</em> – do they win more often than not?</li>
        <li> <em>career games played</em> – do they have a lot of NBA experience?</li>
      </ul>
      <p>
        The only data used from the 2019-20 season is for ordering the players on the teams, the rest
        is using data prior to the season. The top 5 most minutes are separated as the team's core.
      </p>
    </div>
  </header>
  <div class="core-grid">
    {#each teamEntries as [abbr, players], i}
    <div class="item">
      <h2>{players[0].team_full_name}</h2>
      <div class="legends">
        <div class="legend-item"><ColorLegend /></div>
        <div class="legend-item"><GamesPlayedLegend /></div>
        <div class="legend-item"><MinutesLegend /></div>
      </div>
      <div class="core-area">
        <div class="core"><Core team={abbr} {players} /></div>
        <div class="players"><PlayersList {players} /></div>
      </div>
    </div>
    {/each}
  </div>

  <div class="description footer-desc">
    <p>
      Thanks for checking it out! If you have any questions or comments, reach out to me on twitter <a href="https://twitter.com/pbesh">@pbesh</a>.
    </p>
    <p>— <a href="https://peterbeshai.com/">Peter Beshai</a></p>
    <p>Made November 1, 2020</p>
  </div>
    
  </main>
